import { SectionImage } from 'services/api/vehicle-sections/types';
import { useLevel1SectionData } from './useLevel1Section';

export const useDashImages = () => {
  const { images: interiorImages } = useLevel1SectionData('interior_questions');
  const { images: driveCycleImages } = useLevel1SectionData('drive_cycles');

  const firstOdometerImage = interiorImages.find(img => img.type === 'interior.odometer_1');
  const secondOdometerImage = driveCycleImages.find(img => img.type === 'drive_cycles.odometer_2');

  const images = [firstOdometerImage, secondOdometerImage].filter(Boolean) as SectionImage[];
  return images;
};
